module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-2-Article-w720.f315e0af.webp";